import { ReactElement, useEffect } from 'react';
import { useRouteLoaderData } from 'react-router-dom';

import {
  usePaymentStore,
  useValorTitularStore,
  useValorTotalStore,
  useVigenciaStore,
} from '../../../stores/usePaymentStore';

export function DadosEmpresaContent(): ReactElement {
  const data: any = useRouteLoaderData('Empresa-token');
  const vigencia = useVigenciaStore(x => x.vigencia);
  const setVigencia = useVigenciaStore(x => x.setVigencia);
  const setPlano = usePaymentStore(x => x.setId);
  const setValor = useValorTitularStore(x => x.setValor);
  const setValorDep = useValorTotalStore(x => x.setValor);

  useEffect(() => {
    const DataVigencia = calcularDataInicioPagamento(
      data.corte,
      data.competencia,
    );
    if (DataVigencia) {
      setVigencia(DataVigencia);
    }
    setPlano(data.Plano.Id);
    setValor(data.Plano.ValorTitular);
    setValorDep(data.Plano.ValorDependente);
  }, []);

  function calcularDataInicioPagamento(
    diaCorte: number,
    competencia: 1 | 2,
  ): string {
    const hoje = new Date();
    const diaHoje = hoje.getDate();
    const mes = hoje.getMonth();
    const ano = hoje.getFullYear();

    const corteJaPassou = diaHoje > diaCorte;

    let data: Date;

    if (competencia === 2) {
      data = corteJaPassou
        ? new Date(ano, mes + 3, 1)
        : new Date(ano, mes + 2, 1);
    } else {
      data = corteJaPassou
        ? new Date(ano, mes + 2, 1)
        : new Date(ano, mes + 1, 1);
    }

    const dia = String(data.getDate()).padStart(2, '0');
    const mesFormatado = String(data.getMonth() + 1).padStart(2, '0');
    const anoFormatado = data.getFullYear();

    return `${dia}/${mesFormatado}/${anoFormatado}`;
  }

  return (
    <>
      <h3 className="text-high-emphasis text-xl">Resumo da Empresa</h3>
      <span className="flex justify-between uppercase text-medium-emphasis text-xs font-normal">
        <span className="block">
          <span className="block">Nome Fantasia:</span>
          <strong className="block text-neutral-600 normal-case text-sm ">
            {data.nome_fantasia}
          </strong>
        </span>
      </span>
      <span className="flex justify-between uppercase text-medium-emphasis text-xs font-normal">
        <span className="block">
          <span className="block">Plano escolhido:</span>
          <strong className="block text-neutral-600 normal-case text-sm ">
            {data.Plano.Nome}
          </strong>
        </span>
      </span>
      <span className="flex justify-between uppercase text-medium-emphasis text-xs font-normal">
        <span className="block">
          <span className="block">data prevista para início da vigência:</span>
          <strong className="block text-neutral-600 normal-case text-sm">
            {vigencia}
          </strong>
        </span>
      </span>
    </>
  );
}
